import React from 'react';

/**
 * Unified loading spinner used across the entire app.
 *
 * @param {'xs'|'sm'|'lg'} size  — xs (16px, inline buttons), sm (20px, default), lg (40px, full-page)
 * @param {string}  text         — optional label shown beside or below the spinner
 * @param {string}  color        — Tailwind text-color class (default: 'text-brand-600')
 * @param {boolean} center       — if true, wraps in a flex-center container (default: true)
 * @param {string}  className    — extra classes on the wrapper
 */
const sizeMap = {
  xs: 'h-4 w-4',
  sm: 'h-5 w-5',
  lg: 'h-10 w-10',
};

export default function Spinner({
  size = 'sm',
  text,
  color = 'text-brand-600',
  center = true,
  className = '',
}) {
  const svgClasses = `animate-spin ${sizeMap[size] || sizeMap.sm} ${color}`;

  const spinner = (
    <svg
      className={svgClasses}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v8H4z"
      />
    </svg>
  );

  if (!center) {
    return (
      <span className={`inline-flex items-center gap-1.5 ${className}`}>
        {spinner}
        {text && <span className="text-sm text-gray-500">{text}</span>}
      </span>
    );
  }

  return (
    <div className={`flex items-center justify-center ${size === 'lg' ? 'flex-col gap-3 py-12' : 'gap-2'} ${className}`}>
      {spinner}
      {text && <span className="text-sm text-gray-500">{text}</span>}
    </div>
  );
}
